import {Component, EventEmitter, Output, TemplateRef, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';

@Component({
  selector: 'app-channel-duplicate-model',
  templateUrl: './channel-duplicate-modal.component.html'
})
export class ChannelDuplicateModalComponent {
  public size: string = 'modal-sm';
  @ViewChild('channelDuplicateModal') template: TemplateRef<any>;
  @Output() public confirmation: EventEmitter<{confirmed: boolean, data: any}> = new EventEmitter();
  private duplicateData: any;
  private modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private translate: TranslateService
  ) {}

  public show(duplicateData: any) {
    this.duplicateData = duplicateData;
    this.modalRef = this.modalService.show(this.template, this.size);
  }

  public doDecline() {
    this.confirmation.emit({confirmed: false, data: this.duplicateData});
    this.duplicateData = undefined;
    this.modalRef.hide();
  }

  public doConfirm(bIncludeThroughputs) {
    this.duplicateData.bIncludeThroughputs = bIncludeThroughputs;
    this.confirmation.emit({confirmed: true, data: this.duplicateData});
    this.duplicateData = undefined;
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel-duplicate-modal.component.ts